export const MCP_SHELL_ORIGIN = 'https://mcp.orphex.co'
export const MCP_SHELL_LOGIN_URL = `${MCP_SHELL_ORIGIN}/login`
export const MCP_SHELL_SIGNUP_URL = `${MCP_SHELL_ORIGIN}/signup`

/**
 * The Login page's "Start free" target (ORP-26824): a fixed MCP shell sign-up tagged as an
 * app.orphex.co referral. The in-app `/signup` stays, so no visit's attribution is forwarded.
 */
export const MCP_SHELL_START_FREE_URL = `${MCP_SHELL_SIGNUP_URL}?utm_source=app.orphex.co&utm_medium=referral`

export function redirectToMcpShellLogin(
  redirect: (url: string) => void = window.location.assign,
): void {
  redirect(MCP_SHELL_LOGIN_URL)
}
